// The avatar slot for an asset row in the Add-Assets flows.
//
// Browse rows come from QUSHi's curated category lists, which ship real brand
// art — show it. Search results come from the provider and have no logo, so they
// keep the teal initials chip. Both occupy the SAME footprint, so a list never
// shifts when the user starts typing.
//
// The logo is deliberately not clipped to a circle: that would crop marks like
// Microsoft's four squares. Per the app-wide rule for transparent art, it also
// carries no box-shadow.
// `chipClassName` carries the fallback chip's own palette: teal-on-white in the
// Watchlist flows, grey in the chart's symbol-search modal (where it has to match
// the provider search rows sitting directly below it).
export default function AssetAvatar({
  logo,
  chip,
  className = "h-10 w-10",
  chipTextClass = "text-[10px] font-semibold",
  chipClassName = "bg-primaryColor text-white",
}) {
  if (logo) {
    return (
      <img
        src={logo}
        alt=""
        className={`${className} shrink-0 object-contain`}
        // A dead URL would otherwise render the browser's broken-image glyph;
        // hiding it keeps the row's text aligned with its neighbours.
        onError={(e) => {
          e.currentTarget.style.visibility = "hidden";
        }}
      />
    );
  }
  return (
    <div
      className={`${className} ${chipClassName} flex shrink-0 items-center justify-center rounded-full`}
    >
      <span className={`truncate px-0.5 leading-tight ${chipTextClass}`}>{chip}</span>
    </div>
  );
}
